export function createVoicePerformance() {
    let snapshot = { speaking: false, energy: 0, source: 'none' };
    let boundaryTimer;
    const listeners = new Set();
    const update = (next) => {
        if (next.speaking === snapshot.speaking &&
            next.energy === snapshot.energy &&
            next.source === snapshot.source)
            return;
        snapshot = next;
        listeners.forEach((listener) => listener());
    };
    return {
        getSnapshot: () => snapshot,
        subscribe(listener) {
            listeners.add(listener);
            return () => {
                listeners.delete(listener);
            };
        },
        setSpeaking(speaking) {
            clearTimeout(boundaryTimer);
            update({ speaking, energy: 0, source: 'none' });
        },
        sample(frames) {
            if (!snapshot.speaking || !frames.length)
                return;
            clearTimeout(boundaryTimer);
            let sum = 0;
            for (let i = 0; i < frames.length; i++)
                sum += (frames[i] ?? 0) ** 2;
            // A little noise gate keeps the mouth still during pauses. Quantize to limit renders.
            const energy = Math.round(Math.min(1, Math.max(0, Math.sqrt(sum / frames.length) - 0.012) * 7) * 20) / 20;
            update({ speaking: true, energy, source: 'pcm' });
        },
        boundary() {
            if (!snapshot.speaking)
                return;
            clearTimeout(boundaryTimer);
            update({ speaking: true, energy: 0.65, source: 'boundary' });
            boundaryTimer = setTimeout(() => {
                if (snapshot.speaking)
                    update({ speaking: true, energy: 0, source: 'boundary' });
            }, 140);
        },
    };
}
/** One store per running client. Stop resets both the energy and any boundary pulse. */
export const voicePerformance = createVoicePerformance();
//# sourceMappingURL=voice-performance.js.map